import { forwardRef } from "react";

import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { TextBody } from "../../typography/TextBody";
import { EmptyBody } from "./EmptyBody";
import { EmptyHeader } from "./EmptyHeader";
import { TEmptyProps } from "./Empty.config";
import { EmptyIllustration } from "./EmptyIllustration";

export const Empty = forwardRef<HTMLDivElement, TEmptyProps>(
  (
    {
      title,
      children,
      image,
      ...props
    },
    ref,
  ) => (
    <div
      {...props}
      data-component="Empty"
      ref={ref}
      className={cn(
        "flex flex-col gap-4 w-full max-w-80 p-4 mx-auto",
        "xl: max-w-96",
      )}>
      <EmptyHeader>
        <EmptyIllustration image={image} />
      </EmptyHeader>
      <EmptyBody>
        <TextSubtitle size={2} align="center">{ title }</TextSubtitle>
        <TextBody size={2} align="center" color="secondary" isResponsive={false}>{ children }</TextBody>
      </EmptyBody>
    </div>
  ),
);

Empty.displayName = "Empty";
